/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  BulkCategoriesUpdate200,
  BulkCategoriesUpdateBody,
  Category,
  CategoryFolder,
  CreateOrganizationCategoryBody,
  CreateOrganizationCategoryFolderBody,
  ForbiddenResponse,
  InternalServerErrorResponse,
  ListProjectCategories200Item,
  NotFoundResponse,
  UnauthorizedResponse,
  UpdateOrganizationCategoryBody,
  UpdateOrganizationCategoryFolderBody,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all categories for the project
 */
export const listProjectCategories = (
  organizationId: string,
  projectId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ListProjectCategories200Item[]>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/categories`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getListProjectCategoriesQueryKey = (
  organizationId: string,
  projectId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/categories`,
  ] as const;
};

export const getListProjectCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listProjectCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProjectCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListProjectCategoriesQueryKey(organizationId, projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProjectCategories>>
  > = ({ signal }) =>
    listProjectCategories(organizationId, projectId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && projectId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listProjectCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListProjectCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProjectCategories>>
>;
export type ListProjectCategoriesQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useListProjectCategories<
  TData = Awaited<ReturnType<typeof listProjectCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProjectCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectCategories>>,
          TError,
          Awaited<ReturnType<typeof listProjectCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProjectCategories<
  TData = Awaited<ReturnType<typeof listProjectCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProjectCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProjectCategories>>,
          TError,
          Awaited<ReturnType<typeof listProjectCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProjectCategories<
  TData = Awaited<ReturnType<typeof listProjectCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProjectCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all categories for the project
 */

export function useListProjectCategories<
  TData = Awaited<ReturnType<typeof listProjectCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProjectCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListProjectCategoriesQueryOptions(
    organizationId,
    projectId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new category for the organization
 */
export const createOrganizationCategory = (
  organizationId: string,
  createOrganizationCategoryBody: CreateOrganizationCategoryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Category>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-categories`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrganizationCategoryBody,
      signal,
    },
    options
  );
};

export const getCreateOrganizationCategoryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganizationCategory>>,
    TError,
    { organizationId: string; data: CreateOrganizationCategoryBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganizationCategory>>,
  TError,
  { organizationId: string; data: CreateOrganizationCategoryBody },
  TContext
> => {
  const mutationKey = ["createOrganizationCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganizationCategory>>,
    { organizationId: string; data: CreateOrganizationCategoryBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return createOrganizationCategory(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganizationCategory>>
>;
export type CreateOrganizationCategoryMutationBody =
  CreateOrganizationCategoryBody;
export type CreateOrganizationCategoryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a new category for the organization
 */
export const useCreateOrganizationCategory = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrganizationCategory>>,
      TError,
      { organizationId: string; data: CreateOrganizationCategoryBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createOrganizationCategory>>,
  TError,
  { organizationId: string; data: CreateOrganizationCategoryBody },
  TContext
> => {
  return useMutation(
    getCreateOrganizationCategoryMutationOptions(options),
    queryClient
  );
};
/**
 * @summary List all categories for the organization
 */
export const listOrganizationCategories = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Category[]>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-categories`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getListOrganizationCategoriesQueryKey = (
  organizationId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/document-categories`,
  ] as const;
};

export const getListOrganizationCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganizationCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganizationCategoriesQueryKey(organizationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizationCategories>>
  > = ({ signal }) =>
    listOrganizationCategories(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizationCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizationCategories>>
>;
export type ListOrganizationCategoriesQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useListOrganizationCategories<
  TData = Awaited<ReturnType<typeof listOrganizationCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationCategories>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationCategories<
  TData = Awaited<ReturnType<typeof listOrganizationCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationCategories>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationCategories>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationCategories<
  TData = Awaited<ReturnType<typeof listOrganizationCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all categories for the organization
 */

export function useListOrganizationCategories<
  TData = Awaited<ReturnType<typeof listOrganizationCategories>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationCategoriesQueryOptions(
    organizationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a category for the organization
 */
export const updateOrganizationCategory = (
  organizationId: string,
  categoryId: string,
  updateOrganizationCategoryBody: UpdateOrganizationCategoryBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Category>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-categories/${categoryId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateOrganizationCategoryBody,
      signal,
    },
    options
  );
};

export const getUpdateOrganizationCategoryMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationCategory>>,
    TError,
    {
      organizationId: string;
      categoryId: string;
      data: UpdateOrganizationCategoryBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationCategory>>,
  TError,
  {
    organizationId: string;
    categoryId: string;
    data: UpdateOrganizationCategoryBody;
  },
  TContext
> => {
  const mutationKey = ["updateOrganizationCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationCategory>>,
    {
      organizationId: string;
      categoryId: string;
      data: UpdateOrganizationCategoryBody;
    }
  > = (props) => {
    const { organizationId, categoryId, data } = props ?? {};

    return updateOrganizationCategory(
      organizationId,
      categoryId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationCategory>>
>;
export type UpdateOrganizationCategoryMutationBody =
  UpdateOrganizationCategoryBody;
export type UpdateOrganizationCategoryMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update a category for the organization
 */
export const useUpdateOrganizationCategory = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganizationCategory>>,
      TError,
      {
        organizationId: string;
        categoryId: string;
        data: UpdateOrganizationCategoryBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationCategory>>,
  TError,
  {
    organizationId: string;
    categoryId: string;
    data: UpdateOrganizationCategoryBody;
  },
  TContext
> => {
  return useMutation(
    getUpdateOrganizationCategoryMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Delete a category for the organization
 */
export const deleteOrganizationCategory = (
  organizationId: string,
  categoryId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-categories/${categoryId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteOrganizationCategoryMutationOptions = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganizationCategory>>,
    TError,
    { organizationId: string; categoryId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganizationCategory>>,
  TError,
  { organizationId: string; categoryId: string },
  TContext
> => {
  const mutationKey = ["deleteOrganizationCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganizationCategory>>,
    { organizationId: string; categoryId: string }
  > = (props) => {
    const { organizationId, categoryId } = props ?? {};

    return deleteOrganizationCategory(
      organizationId,
      categoryId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganizationCategory>>
>;

export type DeleteOrganizationCategoryMutationError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Delete a category for the organization
 */
export const useDeleteOrganizationCategory = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrganizationCategory>>,
      TError,
      { organizationId: string; categoryId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganizationCategory>>,
  TError,
  { organizationId: string; categoryId: string },
  TContext
> => {
  return useMutation(
    getDeleteOrganizationCategoryMutationOptions(options),
    queryClient
  );
};
/**
 * @summary List all category folders for the organization
 */
export const listOrganizationCategoryFolders = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CategoryFolder[]>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-category-folders`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getListOrganizationCategoryFoldersQueryKey = (
  organizationId: string
) => {
  return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/document-category-folders`,
  ] as const;
};

export const getListOrganizationCategoryFoldersQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganizationCategoryFoldersQueryKey(organizationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizationCategoryFolders>>
  > = ({ signal }) =>
    listOrganizationCategoryFolders(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationCategoryFoldersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizationCategoryFolders>>
>;
export type ListOrganizationCategoryFoldersQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useListOrganizationCategoryFolders<
  TData = Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationCategoryFolders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationCategoryFolders<
  TData = Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationCategoryFolders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationCategoryFolders<
  TData = Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all category folders for the organization
 */

export function useListOrganizationCategoryFolders<
  TData = Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationCategoryFolders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationCategoryFoldersQueryOptions(
    organizationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new category folder for the organization
 */
export const createOrganizationCategoryFolder = (
  organizationId: string,
  createOrganizationCategoryFolderBody: CreateOrganizationCategoryFolderBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CategoryFolder>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-category-folders`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrganizationCategoryFolderBody,
      signal,
    },
    options
  );
};

export const getCreateOrganizationCategoryFolderMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganizationCategoryFolder>>,
    TError,
    { organizationId: string; data: CreateOrganizationCategoryFolderBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganizationCategoryFolder>>,
  TError,
  { organizationId: string; data: CreateOrganizationCategoryFolderBody },
  TContext
> => {
  const mutationKey = ["createOrganizationCategoryFolder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganizationCategoryFolder>>,
    { organizationId: string; data: CreateOrganizationCategoryFolderBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return createOrganizationCategoryFolder(
      organizationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationCategoryFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganizationCategoryFolder>>
>;
export type CreateOrganizationCategoryFolderMutationBody =
  CreateOrganizationCategoryFolderBody;
export type CreateOrganizationCategoryFolderMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a new category folder for the organization
 */
export const useCreateOrganizationCategoryFolder = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrganizationCategoryFolder>>,
      TError,
      { organizationId: string; data: CreateOrganizationCategoryFolderBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createOrganizationCategoryFolder>>,
  TError,
  { organizationId: string; data: CreateOrganizationCategoryFolderBody },
  TContext
> => {
  return useMutation(
    getCreateOrganizationCategoryFolderMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Update a category folder for the organization
 */
export const updateOrganizationCategoryFolder = (
  organizationId: string,
  folderId: number,
  updateOrganizationCategoryFolderBody: UpdateOrganizationCategoryFolderBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CategoryFolder>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-category-folders/${folderId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateOrganizationCategoryFolderBody,
      signal,
    },
    options
  );
};

export const getUpdateOrganizationCategoryFolderMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationCategoryFolder>>,
    TError,
    {
      organizationId: string;
      folderId: number;
      data: UpdateOrganizationCategoryFolderBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationCategoryFolder>>,
  TError,
  {
    organizationId: string;
    folderId: number;
    data: UpdateOrganizationCategoryFolderBody;
  },
  TContext
> => {
  const mutationKey = ["updateOrganizationCategoryFolder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationCategoryFolder>>,
    {
      organizationId: string;
      folderId: number;
      data: UpdateOrganizationCategoryFolderBody;
    }
  > = (props) => {
    const { organizationId, folderId, data } = props ?? {};

    return updateOrganizationCategoryFolder(
      organizationId,
      folderId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationCategoryFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationCategoryFolder>>
>;
export type UpdateOrganizationCategoryFolderMutationBody =
  UpdateOrganizationCategoryFolderBody;
export type UpdateOrganizationCategoryFolderMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update a category folder for the organization
 */
export const useUpdateOrganizationCategoryFolder = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganizationCategoryFolder>>,
      TError,
      {
        organizationId: string;
        folderId: number;
        data: UpdateOrganizationCategoryFolderBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationCategoryFolder>>,
  TError,
  {
    organizationId: string;
    folderId: number;
    data: UpdateOrganizationCategoryFolderBody;
  },
  TContext
> => {
  return useMutation(
    getUpdateOrganizationCategoryFolderMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Delete a category folder for the organization
 */
export const deleteOrganizationCategoryFolder = (
  organizationId: string,
  folderId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-category-folders/${folderId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteOrganizationCategoryFolderMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganizationCategoryFolder>>,
    TError,
    { organizationId: string; folderId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganizationCategoryFolder>>,
  TError,
  { organizationId: string; folderId: number },
  TContext
> => {
  const mutationKey = ["deleteOrganizationCategoryFolder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganizationCategoryFolder>>,
    { organizationId: string; folderId: number }
  > = (props) => {
    const { organizationId, folderId } = props ?? {};

    return deleteOrganizationCategoryFolder(
      organizationId,
      folderId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationCategoryFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganizationCategoryFolder>>
>;

export type DeleteOrganizationCategoryFolderMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Delete a category folder for the organization
 */
export const useDeleteOrganizationCategoryFolder = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrganizationCategoryFolder>>,
      TError,
      { organizationId: string; folderId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganizationCategoryFolder>>,
  TError,
  { organizationId: string; folderId: number },
  TContext
> => {
  return useMutation(
    getDeleteOrganizationCategoryFolderMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Update multiple categories in bulk for an organization
 */
export const bulkCategoriesUpdate = (
  organizationId: string,
  bulkCategoriesUpdateBody: BulkCategoriesUpdateBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<BulkCategoriesUpdate200>(
    {
      url: `https://api.app.sky-tech.ai/organizations/${organizationId}/document-categories/bulk`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: bulkCategoriesUpdateBody,
      signal,
    },
    options
  );
};

export const getBulkCategoriesUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCategoriesUpdate>>,
    TError,
    { organizationId: string; data: BulkCategoriesUpdateBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkCategoriesUpdate>>,
  TError,
  { organizationId: string; data: BulkCategoriesUpdateBody },
  TContext
> => {
  const mutationKey = ["bulkCategoriesUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkCategoriesUpdate>>,
    { organizationId: string; data: BulkCategoriesUpdateBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return bulkCategoriesUpdate(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkCategoriesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkCategoriesUpdate>>
>;
export type BulkCategoriesUpdateMutationBody = BulkCategoriesUpdateBody;
export type BulkCategoriesUpdateMutationError = unknown;

/**
 * @summary Update multiple categories in bulk for an organization
 */
export const useBulkCategoriesUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkCategoriesUpdate>>,
      TError,
      { organizationId: string; data: BulkCategoriesUpdateBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkCategoriesUpdate>>,
  TError,
  { organizationId: string; data: BulkCategoriesUpdateBody },
  TContext
> => {
  return useMutation(
    getBulkCategoriesUpdateMutationOptions(options),
    queryClient
  );
};
